import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["signContainer"]

  connect() {}

  showSignContainer() {
    if (this.hasSignContainerTarget) {
      this.signContainerTarget.classList.contains("hidden") &&
        this.signContainerTarget.classList.remove("hidden")
    }
  }

  hideSignContainer() {
    if (this.hasSignContainerTarget) {
      !this.signContainerTarget.classList.contains("hidden") &&
        this.signContainerTarget.classList.add("hidden")
    }
  }
}
